import React, { useEffect, useState } from 'react';
import Form from 'react-bootstrap/Form';
import { Card, Col, Row } from 'react-bootstrap';
import { Link, useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { BASE_URL } from '../../services/Api';
import { authHeader } from '../../services/auth-header';
import Swal from 'sweetalert2';
import PDCView from './PumpDC/View';
import MDCView from './ManufacturingDC/View';

function DcView() {
  const navigate = useNavigate();
  const { pointindex, id } = useParams();
  const [deliverychallantype, setdeliverychallantype] = useState();
  const [deliverychallancategory, setdeliverychallancategory] = useState();
  const [enquiryData, setenquiryData] = useState();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${BASE_URL}deliveryChallan/findById/${id}`, {
          headers: authHeader(),
        });
        console.log(' id api', response.data);
        setenquiryData(response.data);
        setdeliverychallantype(response.data.deliverychallantype);
        setdeliverychallancategory(response.data.deliverychallancategory);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData();
  }, [id]);
  console.log('aa ', enquiryData);

  const renderPageDisplay = () => {
    if (deliverychallantype === 'Pump Spare' && deliverychallancategory === 'Domestic') {
      return <PDCView enquiryData={enquiryData} />;
    } else if (deliverychallantype === 'Manufacturing' && deliverychallancategory === 'Domestic') {
      return <MDCView enquiryData={enquiryData} />;
    }
    return null; // Default case
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
    });

    if (result.isConfirmed) {
      try {
        const response = await axios.delete(`${BASE_URL}deliveryChallan/delete/${id}`, {
          headers: authHeader(),
        });
        if (response.data.length === 0) {
          Swal.fire('Warning', 'PO is present in another module. Delete operation has been cancelled.', 'warning');
        } else {
          navigate(`/dcindex/${pointindex}`);
          Swal.fire('Deleted!', 'Deleted successfully.', 'success');
        }
      } catch (error) {
        Swal.fire('Error', error.response?.data || 'An error occurred', 'error');
      }
    }
  };

  return (
      <Card className="card">
        <Card.Header className="card-header">
          <h6>VIEW DELIVERY CHALLAN</h6>
          <div>
            <strong>Type:</strong> {deliverychallantype} | <strong>Category:</strong> {deliverychallancategory}
          </div>
          <div className="view-buttons">
            {(deliverychallancategory === "Domestic" || deliverychallancategory === "International") && enquiryData?.status === "Open" && (
              <Link to={`/dctosalesconvert/${id}`}>
                <button className="button-70">Convert To Sales</button>
              </Link>
            )}
            {/* <button className="button-70" onClick={() => handleDelete(id)}>DELETE</button> */}

            {enquiryData?.status === "Open" && enquiryData?.status !== "Cancelled" && (
              <Link to={`/dcEdit/${id}/${pointindex}`}>
                <button className="button-70">EDIT</button>
              </Link>
            )}
            <Link to={`/dcindex/${pointindex}`}>
              <button className="button-70">BACK</button>
            </Link>
          </div>
        </Card.Header>
        {renderPageDisplay()}
      </Card>
  );
}

export default DcView;
